import { ListItemText, TextField, TextFieldVariants } from "@mui/material";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";

type SelectProps = {
  selectValues: any[];
  selectStyle: TextFieldVariants | undefined;
  label: string | null;
  value: any;
  setValue: any;
};

const BasicSelect = ({
  value,
  setValue,
  selectValues,
  selectStyle,
  label,
}: SelectProps) => {
  const { t } = useTranslation();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value as string);
  };

  return (
    <FormControl fullWidth>
      <TextField
        fullWidth
        select
        id="basic-select"
        size="small"
        value={value}
        onChange={handleChange}
        variant={selectStyle}
        placeholder="Select"
        label={label}
        required
      >
        {selectValues.map((value) => (
          <MenuItem key={value.id} value={value.id}>
            <ListItemText primary={t(value.name)} />
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default BasicSelect;
